import Div from "../../components/common/Div";
import React, { useState } from "react";
import InfoBar from "../Partials/IconBar";
import IconBar from "../Partials/IconBar";
import { useHistory } from "react-router-dom";
import Button from "../../components/common/Button";
import Question from "./Question";
import { Typography } from "@mui/material";

export default function EditReviewQuestion(props) {
  const history = useHistory();
  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined ||
    props.location.state.test === undefined ||
    props.location.state.submission === undefined ||
    props.location.state.startTime === undefined ||
    props.location.state.questions === undefined ||
    props.location.state.questionNumber === undefined
  )
    history.push("/login");

  const user = props.location.state.user;
  const test = props.location.state.test;
  let submission = props.location.state.submission;
  const startTime = props.location.state.startTime;
  const questions = props.location.state.questions;
  const questionNumber = props.location.state.questionNumber;
  const groupTest = props.location.state.groupTest;
  function saveSubmission() {
    history.push("/review", {
      user: user,
      test: test,
      questions: questions,
      submission: submission,
      startTime: startTime,
      grouptest: groupTest,
    });
  }
  return (
    <div
      style={{
        maxWidth: "100%",
        maxHeight: "1600px",
      }}
    >
      <div style={{ padding: "10px 20px" }}>
        <div className="HeaderBox">
          <IconBar location={"editQuestion"} user={user} test={test} />
        </div>
        <Typography
          variant="h6"
          style={{
            fontWeight: "bold",
            color: "#fbcd02",
            padding: "5px",
            textAlign: "left",
            marginBottom: "5px",
            fontSize: "1.1rem",
          }}
        >
          Edit Question
        </Typography>

        <hr
          style={{
            marginBottom: "20px",
            borderColor: "#FBCD02",
            borderWidth: "1px",
            borderStyle: "solid",
            width: "100%",
          }}
        />

        <div
          style={{
            fontSize: "0.9rem",
            backgroundColor: "rgb(33, 42, 65)",
            padding: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "15px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            Question {questionNumber + 1}
            <div>
              <Question
                question={questions[questionNumber]}
                submission={submission}
                questionNumber={questionNumber}
                setSubmission={() => {}}
              ></Question>
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <Button
              fontSize={"1rem"}
              padding={"15px 15px"}
              width={"100%"}
              marginTop={"15px"}
              borderRadius={"5px"}
              backgroundColor={"#fbcd02"}
              color={"#00112e"}
              fontWeight={"bold"}
              textTransform={"uppercase"}
              onClick={saveSubmission}
            >
              SAVE
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
